import { flatten } from './flatten';
import { purry } from './purry';
export function flatMap() {
    return purry(_flatMap, arguments);
}
function _flatMap(array, fn) {
    return flatten(array.map(function (item, index, array) { return fn(item, index, array); }));
}
